export default __webpack_public_path__ + "56a7c1fdda6f0f53dc906c45f2f8a375.gif";